import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d2f4c0d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0d2f4c0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f4c0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2f4c0d')) {
      api.createRecord('0d2f4c0d', component.options)
    } else {
      api.reload('0d2f4c0d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d2f4c0d&scoped=true&", function () {
      api.rerender('0d2f4c0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Agreement/index.vue"
export default component.exports